<template>
  <div class="ai-autopilot" :key="componentKey">
    <h2 class="ai-autopilot__title">My tasks</h2>
    <p v-if="!openAiKeyPresent">
      To use AI Autopilot, add OpenAI key in <a href="/integrations" target="_blank">organization settings</a>.
    </p>
    <div class="ai-autopilot__list">
      <CardAIAutopilotTask
        v-for="(task, index) in activeTasks"
        :task="task"
        :location-id="locationId"
        :key="`active-task-${index}`"
        :can-regenerate="openAiKeyPresent"
        class="ai-autopilot__item"
        @updateTask="updateTask" />
      <span v-if="!activeTasks.length">
        No tasks yet
      </span>
    </div>
    <hr class="ai-autopilot__separator">
    <h2 class="ai-autopilot__title">Recent automations</h2>
    <div class="ai-autopilot__list">
      <CardAIAutopilotTask
        v-for="(task, index) in recentTasks"
        :task="task"
        :location-id="locationId"
        :key="`recent-task-${index}`"
        class="ai-autopilot__item" />
      <span v-if="!recentTasks.length">
        No recent automations yet
      </span>
    </div>
    <Pagination
      v-if="false"
      :page="currentPage"
      :per-page="perPage"
      :total-count="totalTasks"
      @updatePage="updatePageNumber" />
  </div>
</template>

<script>
import axiosTransform from 'common/axios'
import Pagination from 'vue_widgets/components/pagination'
import CardAIAutopilotTask from './blanks/CardAIAutopilotTask'

export default {
  components: {
    CardAIAutopilotTask,
    Pagination
  },
  props: {
    locationId: {
      type: String,
      required: true
    },
    openAiKeyPresent: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalTasks: 0,
      tasks: [],
      componentKey: 0
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    activeTasks() {
      return this.tasks.filter(({ status }) => status === 'draft')
    },
    recentTasks() {
      return this.tasks.filter(({ status }) => status !== 'draft')
    }
  },
  methods: {
    fetchTasks(params = {}) {
      return axios
        .get(`/api/organizations_locations/${this.locationId}/ai_autopilot`, {
          params,
          ...axiosTransform
        })
        .then((res) => res.data)
    },
    async fetchData() {
      const activeTasks = await this.fetchTasks({
        byStatuses: ['draft']
      })
      const recentlyCompleteTasks = await this.fetchTasks({
        recentlyCompleted: 6
      })
      this.tasks = activeTasks.concat(recentlyCompleteTasks)
    },
    updateTask(newTaskData) {
      const relatedTaskIndex = this.tasks.findIndex((task) => task.id === newTaskData.id)
      if (relatedTaskIndex === -1) return false

      this.$set(this.tasks, relatedTaskIndex, newTaskData)
      this.componentKey++

      return true
    },
    updatePageNumber(page) {
      this.currentPage = page
      this.fetchTasks()
    }
  }
}
</script>
